import Axios from "axios";
import {
    SET_PROJECT_AUTHOR_LIST,
    UNSET_PROJECT_AUTHOR_LIST,
  } from "@/store/mutation-types";
import { saveUpdateAuthor, getAuthorList } from "@/store/api";
// initial state
const state = {
  getAuthorList: [],
};

const getters = {
  getAuthorList(state) {
    return state.getAuthorList;
  },
};

const mutations = {
  [SET_PROJECT_AUTHOR_LIST](state, data) {
    state.getAuthorList = data;
  },
  [UNSET_PROJECT_AUTHOR_LIST](state) {
    state.getAuthorList = [];
  },

};

const actions = {

  saveUpdateAuthor({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateAuthor, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getAuthorList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getAuthorList, data)
        .then(function (response) {
          commit('SET_PROJECT_AUTHOR_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PROJECT_AUTHOR_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};